<template>
  <div class="pa-10">
    <h1 class="display-1 text-center mb-8">Covid Test</h1>

    <form class="personal-info d-flex flex-column" @submit.prevent="submit">
      <div class="subtitle-1 font-weight-bold mb-2">2. {{$t('cellexTest.second.secondTitle')}}</div>

      <v-text-field
        class="flex-grow-0"
        :label="$t('cellexTest.second.tripTypeLabel')"
        v-model="tripType"
      ></v-text-field>

      <v-radio-group
        v-model="accompanied"
        column
        dense
        :label="$t('cellexTest.second.accompaniedLabel')"
        class="align-self-start"
      >
        <v-radio :label="$t('cellexTest.second.yes')" :value="true" color="primary" :ripple="false"></v-radio>
        <v-radio :label="$t('cellexTest.second.no')" :value="false" color="primary" :ripple="false"></v-radio>
      </v-radio-group>

      <v-text-field
        class="flex-grow-0"
        :label="$t('cellexTest.second.peopleAccompaniedLabel')"
        type="number"
        min="1"
        :disabled="!accompanied"
        v-model="peopleAccompanied"
      ></v-text-field>

      <v-text-field
        class="flex-grow-0"
        :label="$t('cellexTest.second.arrivalPlaceLabel')"
        v-model="arrivalPlace"
      ></v-text-field>

      <v-text-field
        class="flex-grow-0"
        :label="$t('cellexTest.second.departurePlaceLabel')"
        v-model="departurePlace"
      ></v-text-field>

      <v-text-field
        class="flex-grow-0"
        :label="$t('cellexTest.second.residencePlaceLabel')"
        v-model="residencePlace"
      ></v-text-field>

      <v-text-field
        class="flex-grow-0"
        :label="$t('cellexTest.second.transportMeanLabel')"
        v-model="transportMean"
      ></v-text-field>

      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="travelDatesFormatted"
            :label="$t('cellexTest.second.travelDatesLabel')"
            prepend-inner-icon="mdi-calendar"
            class="flex-grow-0"
            v-on="on"
            readonly
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="travelDates"
          no-title
          color="primary"
          range
          :min="new Date().toISOString()"
          @input="closePicker"
        ></v-date-picker>
      </v-menu>

      <v-text-field
        class="flex-grow-0"
        :label="$t('cellexTest.second.stayingDaysLabel')"
        :value="stayingDays"
        :readonly="travelDates.length == 2"
        :disabled="travelDates.length != 2"
      ></v-text-field>

      <v-btn
        color="primary"
        depressed
        class="align-self-center"
        type="submit"
      >{{$t('cellexTest.second.btn')}}</v-btn>
    </form>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      tripType: "",
      accompanied: false,
      peopleAccompanied: null,
      arrivalPlace: "",
      departurePlace: "",
      residencePlace: "",
      transportMean: "",
      travelDates: [],
      menu: false
    };
  },
  computed: {
    ...mapState({
      newCellexTest: state => state.frontDesk.newCellexTest
    }),
    travelDatesFormatted() {
      if (this.travelDates.length != 2) return "";
      const formattedDates = [];
      const startDate = moment(this.travelDates[0]).format("DD/MM/YYYY");
      const returnDate = moment(this.travelDates[1]).format("DD/MM/YYYY");
      formattedDates.push(startDate);
      formattedDates.push(returnDate);
      return formattedDates.join(" ~ ");
    },
    stayingDays() {
      if (this.travelDates.length != 2) return "";
      return moment(this.travelDates[1]).diff(
        moment(this.travelDates[0]),
        "days"
      );
    }
  },
  created() {
    this.tripType = this.newCellexTest?.tripInfo?.tripType;
    this.accompanied = !!this.newCellexTest?.tripInfo?.accompanied;
    this.peopleAccompanied = this.newCellexTest?.tripInfo?.accompanied
      ? this.newCellexTest?.tripInfo?.peopleAccompanied
      : null;
    this.arrivalPlace = this.newCellexTest?.tripInfo?.arrivalPlace;
    this.departurePlace = this.newCellexTest?.tripInfo?.departurePlace;
    this.residencePlace = this.newCellexTest?.tripInfo?.residencePlace;
    this.transportMean = this.newCellexTest?.tripInfo?.transportMean;
    this.travelDates = this.newCellexTest?.tripInfo?.travelDates
      ? this.newCellexTest?.tripInfo?.travelDates.map(date =>
          moment(date).toISOString()
        )
      : [];
  },
  methods: {
    ...mapActions(["newCellexTestSecond"]),
    closePicker() {
      if (this.travelDates.length != 2) return;
      this.menu = false;
    },
    submit() {
      this.newCellexTestSecond({
        tripType: this.tripType,
        accompanied: this.accompanied,
        peopleAccompanied: this.accompanied ? this.peopleAccompanied : null,
        arrivalPlace: this.arrivalPlace,
        departurePlace: this.departurePlace,
        residencePlace: this.residencePlace,
        transportMean: this.transportMean,
        travelDates: this.travelDates.map(date => moment(date).toDate()),
        stayingDays: this.stayingDays
      });
    }
  },
  watch: {
    travelDates() {
      if (this.travelDates.length != 2) return;
      if (moment(this.travelDates[0]) <= moment(this.travelDates[1])) return;
      this.travelDates.sort((a, b) => {
        a = moment(a);
        b = moment(b);
        return a < b ? -1 : a > b ? 1 : 0;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>